module.exports = __webpack_public_path__ + "img/search1.0c2fd712.png";